import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

//Config file to support multiple language using i18n
i18n.use(initReactI18next).init({
  fallbackLng: 'English',
  resources: {
    English: {
      translations: require('./locales/translation-english.json'),
    },
    Spanish: {
      translations: require('./locales/translation-spanish.json'),
    },
    French: {
      translations: require('./locales/translation-french.json'),
    },
  },
  ns: ['translations'],
  defaultNS: 'translations',
});

i18n.languages = ['English', 'Spanish', 'French'];

export default i18n;
